import Parse from "parse";
import React from "react";

import { AdminLayout, useNavigation, useTranslation } from "@opendash/core";

import { useNavigate } from "react-router";

import {
  Container,
  ContainerInner,
  Element,
} from "@opendash/core/dist/components/OpenDashFrontpage.layout";
import { useParseQuery } from "parse-hooks";
import { TenantDomain } from "../types";

export const AdminRoute = React.memo(function AdminRoute() {
  const t = useTranslation();
  const navigate = useNavigate();

  const { result } = useParseQuery(
    React.useMemo(
      () =>
        new Parse.Query(TenantDomain)
          .equalTo("tenant", Parse.User.current()?.get("tenant"))
          .notContainedIn("domain", ["127.0.0.1", "localhost"]),
      []
    )
  );

  const [allGroups, allItems] = useNavigation("sidebar");

  const group = allGroups.find((group) => group.label === "app:admin.title");
  const items = allItems
    .filter((item) => item.group === group?.id)
    .filter((item) => item.link)
    .filter((item) => item.icon)
    .map((item) => ({
      ...item,
      onClick: () => {
        if (item.link) {
          navigate(item.link);
        }
      },
    }));

  return (
    <AdminLayout contentPadding>
      <Container>
        <ContainerInner>
          {result.map((domain) => (
            <Element
              key={domain.id}
              label={domain.get("domain")}
              icon="fa:browser"
              color="#1890ff"
              onClick={() => {
                window
                  ?.open("https://" + domain.get("domain"), "_blank")
                  ?.focus();
              }}
            />
          ))}

          {items.map((e) => (
            <Element key={e.id} {...e} />
          ))}

          {items.length === 0 && t("opendash:frontpage.empty")}
        </ContainerInner>
      </Container>
    </AdminLayout>
  );
});
